import { DecimalField } from '@ff-it/form';
import { FactorForm, FactorKind } from 'core/types';
import { useFieldValue } from 'hooks';
import { ReactElement } from 'react';
import { required } from 'utilities';
import { MonthFactors } from './MonthFactors';
import { WeekFactors } from './WeekFactors';
import { factorFormLabels } from './const';
import { LengthFactors } from './LengthFactors';
import { Box } from '@ff-it/ui';

export function FactorKindRateFields(): ReactElement {
  const kind = useFieldValue<FactorKind>('kind');
  const form = useFieldValue<FactorForm>('form');
  const label = factorFormLabels[form];

  switch (kind) {
    case 'CONSTANT':
      return (
        <div className="form-row">
          <DecimalField precision={2} name="rate" label={label} required validate={required} className="col-6" />
        </div>
      );
    case 'MONTHLY':
      return <MonthFactors name="rates" label={label} />;
    case 'WEEKLY':
      return <WeekFactors name="rates" label={label} />;
    case 'LENGTH':
      return (
        <Box width={'1/2'}>
          <LengthFactors label={label} />
        </Box>
      );
    default:
      throw new Error(`Unknown kind ${kind}`);
  }
}
